import React, { useState } from 'react';
import { Descriptions, Card, Button } from 'antd';
import api from '@services/api';
import { useHistory, useParams } from 'react-router-dom';
import { Firmware } from '@services/types';
import styles from './firmware-info.module.scss';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Navigation } from '@constants/Navigation';

const InfoFirmwareModal = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const [firmware, setFirmware] = useState<Firmware>();

  const onClose = () => {
    history.push(Navigation.Firmwares);
  };

  React.useEffect(() => {
    api.firmwares.getFirmwaresById(id).then((firmwars) => {
      setFirmware(firmwars);
    });
  }, []);
  return (
    <Card
      title="Firmware info"
      style={{ marginBottom: '1rem' }}
      extra={
        <Button icon={<ArrowLeftOutlined />} type="default" onClick={onClose}>
          Back to Firmwares Page
        </Button>
      }
    >
      <Descriptions labelStyle={{ fontWeight: 'bold', fontSize: '16px' }} layout="horizontal" column={1} bordered>
        <Descriptions.Item label={<span className={styles.label}>Name</span>}>{firmware?.name}</Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Type</span>}>{firmware?.type}</Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Version</span>}>{firmware?.version}</Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Compilation date</span>}>
          {firmware?.date?.toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Device Types</span>}>
          {firmware?.deviceTypes?.map((deviceType) => deviceType)?.join()}
        </Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Modification date</span>}>
          {firmware?.modifiedAt?.toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Creation date</span>}>
          {firmware?.createdAt?.toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Client</span>}>{firmware?.client}</Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Creator</span>}>
          {firmware?.createdBy}
        </Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Comment</span>}>{firmware?.comment}</Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>File version</span>}>
          {firmware?.fileVersion}
        </Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Modifier</span>}>
          {firmware?.modifiedBy}
        </Descriptions.Item>
        <Descriptions.Item label={<span className={styles.label}>Applied upgrade rules</span>}>
          {firmware?.appliedUpgradeRules?.join()}
        </Descriptions.Item>
        {firmware?.downloadUrl && (
          <Descriptions.Item label={<span className={styles.label}>Download Url</span>}>
            <a href={firmware?.downloadUrl}>{firmware?.downloadUrl}</a>
          </Descriptions.Item>
        )}
        <Descriptions.Item label={<span className={styles.label}>Uploaded Files</span>}>
          {firmware?.name}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default React.memo(InfoFirmwareModal);
